import { INotificationTransformer } from "../NotificationStore";
import { Routes } from "../../../components/Navigation/Routes";
import {
    NotificationType,
    NotificationArgument,
} from "stores/RealTimeMessages/MessageStoreBase";
import React from "react";
import ConversationCommentNoticiation from "stores/RealTimeMessages/ConversationCommentNotification";
import { observable } from "mobx";

export class ConversationCommentActionNotificationArgument {
    id?: string;
    conversationId: string;
    fullName: string;
    titleMessage: string;
    message: string;
    timestamp: string;
    iconInitial: string;
    type: NotificationType;

    @observable read: boolean = false;

    static fromJson(json: ConversationCommentActionNotificationArgument) {
        return Object.assign(
            new ConversationCommentActionNotificationArgument(),
            json,
        );
    }

    static buildNotificationTransformer: () => INotificationTransformer<ConversationCommentActionNotificationArgument> =
        () => {
            return (
                notificationJson: ConversationCommentActionNotificationArgument,
            ) => {
                const commentNotification =
                    ConversationCommentActionNotificationArgument.fromJson(
                        notificationJson,
                    );

                let appPath = Routes.makeConversationsRoute(
                    commentNotification.conversationId,
                );

                let message = (
                    <ConversationCommentNoticiation
                        notification={commentNotification}
                        appPath={appPath}
                    />
                );

                return {
                    notificationOverride: message,
                    title: commentNotification.titleMessage,
                    timestamp: commentNotification.timestamp,
                    message: commentNotification.message,
                } as NotificationArgument;
            };
        };
}
